export * from './score-highlight.module';